import { Activity, Plug, UsersRound, Settings as SettingsIcon, Workflow, BookUser, History, Inbox as InboxIcon, Smartphone, CalendarClock, LayoutDashboard, ListOrdered, Music, ParkingSquare, Phone, PhoneCall, Users, type LucideIcon } from 'lucide-react';
import type { Permission } from '@voice/shared';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Ohne Angabe sehen es alle angemeldeten Benutzer. */
  permission?: Permission;
  end?: boolean;
}

/** Jeder Eintrag erscheint nur, wenn der Benutzer das Recht dafür hat. */
export const NAV: NavItem[] = [
  { to: '/', label: 'Übersicht', icon: LayoutDashboard, end: true },
  { to: '/mein-telefon', label: 'Mein Telefon', icon: Smartphone },
  { to: '/anrufe', label: 'Anrufliste', icon: History },
  { to: '/nachrichten', label: 'Nachrichten', icon: InboxIcon },
  { to: '/team', label: 'Team', icon: UsersRound },
  { to: '/kontakte', label: 'Kontakte', icon: BookUser },
  { to: '/live', label: 'Live-Ansicht', icon: Activity, permission: 'queues.supervise' },
  { to: '/warteschlangen', label: 'Warteschlangen', icon: ListOrdered, permission: 'queues.manage' },
  { to: '/leitungen', label: 'Leitungen', icon: PhoneCall, permission: 'trunks.manage' },
  { to: '/ablaeufe', label: 'Abläufe und Sekretariat', icon: Workflow, permission: 'callflows.manage' },
  { to: '/ansagen', label: 'Ansagen und Musik', icon: Music, permission: 'media.manage' },
  { to: '/zeiten', label: 'Geschäftszeiten', icon: CalendarClock, permission: 'schedules.manage' },
  { to: '/parken', label: 'Parken und Konferenz', icon: ParkingSquare, permission: 'callflows.manage' },
  { to: '/nebenstellen', label: 'Nebenstellen', icon: Phone, permission: 'extensions.manage' },
  { to: '/schnittstellen', label: 'Schnittstellen', icon: Plug, permission: 'integrations.manage' },
  { to: '/einstellungen', label: 'Einstellungen', icon: SettingsIcon },
  { to: '/benutzer', label: 'Benutzer', icon: Users, permission: 'users.manage' },
];
